module.exports = __webpack_public_path__ + "img/bkex.dd59def9.svg";